<template>
  <q-card class="form-card">
    <q-card-section class="row items-center q-pb-none">
      <div class="text-h6">{{ data.title }}</div>
      <q-space />
      <q-btn icon="close" flat round dense @click="closeModal" />
    </q-card-section>

    <q-card-section>
      <q-tabs v-model="mode" dense class="text-grey" active-color="primary" indicator-color="primary" align="justify">
        <q-tab name="manual" label="Ручное добавление" />
        <q-tab name="auto" label="Массовое добавление" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="mode" animated class="form-panels">
        <!-- Ручное добавление -->
        <q-tab-panel name="manual">
          <q-form @submit="onSubmitManual" class="form">
            <div class="form__item">
              <CustomInput 
                label="Номер этажа" 
                :value="manualFormData.level_num"
                @change_input="(value) => onChangeManual('level_num', value)" 
                required 
              />
            </div>
            <div class="form__item">
              <CustomDate 
                label="Дата начала" 
                :value="manualFormData.level_date_start"
                @change_date="(value) => onChangeManual('level_date_start', value)"
                :minDate="workGroupDateStart"
                :maxDate="workGroupDateEnd"
              />
            </div>
            <div class="form__item">
              <CustomDate 
                label="Дата окончания" 
                :value="manualFormData.level_date_end"
                @change_date="(value) => onChangeManual('level_date_end', value)"
                :minDate="workGroupDateStart"
                :maxDate="workGroupDateEnd"
              />
            </div>
            <CustomModalFooter :btn-loading="loading" />
          </q-form>
        </q-tab-panel>

        <!-- Массовое добавление -->
        <q-tab-panel name="auto">
          <q-form @submit="onSubmitAuto" class="form">
            <div class="form__item">
              <CustomInput 
                label="Начальный этаж" 
                :value="autoFormData.level_start"
                @change_input="(value) => onChangeAuto('level_start', value)" 
                type="number"
                required 
              />
            </div>
            <div class="form__item">
              <CustomInput 
                label="Конечный этаж" 
                :value="autoFormData.level_end"
                @change_input="(value) => onChangeAuto('level_end', value)" 
                type="number"
                required 
              />
            </div>
            <div class="form__item">
              <CustomDate 
                label="Дата начала работ" 
                :value="autoFormData.date_start"
                @change_date="(value) => onChangeAuto('date_start', value)" 
                required
                :minDate="workGroupDateStart"
                :maxDate="workGroupDateEnd"
              />
            </div>
            <div class="form__item">
              <CustomInput 
                label="Дней на этаж" 
                :value="autoFormData.days_per_level"
                @change_input="(value) => onChangeAuto('days_per_level', value)" 
                type="number"
                required 
              />
            </div>
            <CustomModalFooter :btn-loading="loading" btn-text="Создать" />
          </q-form>
        </q-tab-panel>
      </q-tab-panels>
    </q-card-section>
  </q-card>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";

export default {
  name: "AddWorkGroupLevel",
  components: { CustomModalFooter, CustomInput, CustomDate },
  props: ['data'],
  data() {
    return {
      loading: false,
      mode: 'manual',
      manualFormData: {
        work_group_id: this.data?.body?.work_group_id || null,
        level_num: '',
        level_date_start: '',
        level_date_end: '',
      },
      autoFormData: {
        work_group_id: this.data?.body?.work_group_id || null,
        level_start: '',
        level_end: '',
        date_start: '',
        days_per_level: '',
      }
    }
  },
  computed: {
    workGroupDateStart() {
      return this.data?.body?.work_group_date_start || null;
    },
    workGroupDateEnd() {
      return this.data?.body?.work_group_date_end || null;
    }
  },
  methods: {
    onChangeManual(key, value) {
      this.manualFormData[key] = value
    },
    onChangeAuto(key, value) {
      this.autoFormData[key] = value
    },
    async onSubmitManual() {
      this.loading = true
      await this.data?.onSubmitManual(this.manualFormData)
      this.loading = false
    },
    async onSubmitAuto() {
      this.loading = true
      await this.data?.onSubmitAuto(this.autoFormData)
      this.loading = false
    },
  },
  setup() {
    const { closeModal } = useAppStore();
    return { closeModal };
  },
}
</script>

<style scoped>
.form-card {
  min-width: 500px;
}

.form-panels {
  background: transparent;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form__item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>

